import apiInstance from '../configs/ApiInstance'

const GetAdminData = async () => {
    const response = await apiInstance.adminService.get();
    return response.data;
}

export default GetAdminData;